import app from './index.js';
import config from './config/app.prod.js';

app(config);
